import React, { useMemo, useState, useEffect } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import { getPastMonthsListWithNames } from "../../../../util/helpers";

const UserAddedDataTable = (props) => {
  const getSignedUpPatients = (groupId, monthString) => {
    try {
      const temp = props?.monthwiseData[groupId?.toString()] || null;
      if (!temp) {
        return 0;
      }
      return temp["count"][monthString] || 0;
    } catch (e) {
      console.log(e, "Error in getting month's revenues");
      return 0;
    }
  };

  const [data, setData] = useState([...props?.healthcareGroups]);
  const columnMonths = getPastMonthsListWithNames(props?.months || 12);
  useEffect(() => {
    if (!props?.loading) {
      setData([...props?.healthcareGroups]);
    }
  }, [props?.loading, props?.healthcareGroups]);

  let renderColumns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Created",
      accessor: "created",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell?.value || "Not Specified"}
          </span>
        );
      },
    },
  ];

  columnMonths.forEach((month) => {
    renderColumns.push({
      Header: month,
      accessor: (d) => d.id,
      Cell: ({ cell }) => {
        const tempCount = getSignedUpPatients(cell?.value, month);
        return (
          <span style={{ textTransform: "capitalize" }}>
            {tempCount || "0"}
          </span>
        );
      },
    });
  });

  const columns = useMemo(() => renderColumns, [props?.loading, props?.months]);

  return (
    <div className="container-fluid w-100">
      {props?.loading ? (
        <PatientLoader text="" />
      ) : (
        <div
          className="container-fluid"
          style={{
            padding: "0px",
            margin: "0px",
            overflowX: "scroll",
            overflow: "scroll",
            overflowY: "hidden",
          }}
        >
          <TableContainer
            columns={columns}
            data={data}
            loading={props?.loading}
          />
        </div>
      )}
    </div>
  );
};

export default UserAddedDataTable;
